document.addEventListener("alpine:init", () => {
  // Stores
  Alpine.store("global", {
    productCanvas: null,
    localizationUrl: "",
    init() {
      // Enable Bootstrap tooltips
      const tooltipTriggerList = document.querySelectorAll(
        '[data-bs-toggle="tooltip"]'
      );
      const tooltipList = [...tooltipTriggerList].map(
        (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
      );

      window.addEventListener("DOMContentLoaded", (event) => {
        this.productCanvas = new bootstrap.Offcanvas("#productCanvas");
      });
    },
    setShopData(localizationUrl) {
      this.localizationUrl = localizationUrl;
    },
    fetchAndReplaceContent(path, stageToUpdate, productCanvas = false) {
      // console.log(path)
      return fetch(path, {
        method: "GET",
      })
        .then((response) => response.text())
        .then((data) => {
          document.querySelector(stageToUpdate).innerHTML = data;
          if (productCanvas) {
            this.productCanvas.show();

            let owlProductDetailCarousel = $(
              ".product-detail-carousel .owl-carousel"
            );
            owlProductDetailCarousel.owlCarousel({
              items: 1,
              margin: 5,
              loop: true,
              autoplay: false,
              nav: false,
              dots: false,
              center: true,
              URLhashListener: false,
              autoplayHoverPause: true,
              startPosition: "URLHash",
            });
            // custom navi for product single
            $(".owl-car-nav-prev").click(function () {
              owlProductDetailCarousel.trigger("prev.owl.carousel");
            });
            $(".owl-car-nav-next").click(function () {
              owlProductDetailCarousel.trigger("next.owl.carousel");
            });

            $(".image-link").each((i, e) => {
              $(e).click((ev) => {
                ev.preventDefault();
                owlProductDetailCarousel.trigger("to.owl.carousel", i, 0);
              });
            });
          }
        });
    },
    switchBackgroundImage(el) {
      el.style.backgroundImage = `url(` + el.dataset.backgroundImage;
      +`)`;
      el.addEventListener("mouseenter", () => {
        el.style.backgroundImage = `url(` + el.dataset.backgroundHoverImage;
        +`)`;
      });
      el.addEventListener("mouseleave", () => {
        el.style.backgroundImage = `url(` + el.dataset.backgroundImage;
        +`)`;
      });
    },
    equalHeight(targetElement, sourceElement, adjustTarget = 0) {
      let newHeight = sourceElement.clientHeight + adjustTarget;
      targetElement.style.height = newHeight + "px";
    },
  });
  // I know it's not a store but let it here so the localization url is set and the following stores can use it for operations.
  // dont find other ways to provide shopify template data then over AlpineDataComponents
  Alpine.data("AtomShopData", (element) => {
    return {
      init() {
        Alpine.store("global").setShopData(element.dataset.localizationUrl);
      },
    };
  });
  Alpine.store("user", {
    user: null,
    init() {
      this.updateUserView();
      let urlArray = document.URL.split("#");
      if (urlArray[1] === "welcome") {
        document.getElementById("mini-user-link").click();
      }
    },
    updateUserView() {
      if (document.getElementById("userCanvasDetails")) {
        Alpine.store("global").fetchAndReplaceContent(
          Alpine.store("global").localizationUrl + "?view=customer",
          "#userCanvasDetails"
        );
      }
    },
  });
  Alpine.store("cart", {
    cartCanvas: null,
    itemCount: 0,
    items: [],
    totalPrice: 0.0,
    init() {
      this.readCart();
      window.addEventListener("DOMContentLoaded", (event) => {
        this.cartCanvas = new bootstrap.Offcanvas("#cartCanvas");
      });
    },
    readCart() {
      fetch("/cart.js", {
        method: "GET",
      })
        .then((response) => response.json())
        .then((data) => {
          this.itemCount = data.item_count;
          this.items = data.items;
          this.totalPrice = data.total_price + data.currency;
          return data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },
    createCartLine(itemId, qnt) {
      let addToCartItems = [{ id: itemId, quantity: qnt }];
      return fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: addToCartItems }),
      })
        .then((response) => response.json())
        .then((data) => {
          this.updateCartView();
          return data;
        })
        .catch((error) => {
          console.error(error);
          return error;
        });
    },
    updateCartLine(items) {
      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: items }),
      })
        .then((response) => {
          this.updateCartView();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateCartView() {
      this.readCart();
      Alpine.store("global").fetchAndReplaceContent(
        Alpine.store("global").localizationUrl + "?view=cart",
        "#cartCanvas .offcanvas-body"
      );
      Alpine.store("global").fetchAndReplaceContent(
        Alpine.store("global").localizationUrl + "?view=cart-oversell",
        "#oversell-area"
      );
      if (document.getElementById("cartPageItemsWrapper")) {
        Alpine.store("global").fetchAndReplaceContent(
          Alpine.store("global").localizationUrl + "?view=cart-page",
          "#cartPageItemsWrapper"
        );
      }
      setTimeout(() => {
        if (Alpine.store("cart").itemCount > 0) {
          //this.cartCanvas.show()
        }
      }, 400);
    },
  });

  // Data
  Alpine.data("layoutTheme", (element) => {
    return {
      init() {
        this.adjustPaddingTop(element);
        addEventListener("load", (event) => {
          this.adjustPaddingTop(element);
        });
        addEventListener("resize", (event) => {
          this.adjustPaddingTop(element);
        });
      },
      adjustPaddingTop(element) {
        element.style.paddingTop =
          this.$refs.headerReference.clientHeight + "px";
        element.dataset.padding = this.$refs.headerReference.clientHeight;
      },
    };
  });
  Alpine.data("moleculeProductList", () => {
    return {
      loading: false,
      init() {},
      readProducts() {
        this.loading = true;
      },
    };
  });
  Alpine.data("moleculeProductListItem", (el) => {
    return {
      available: true,
      quantity: 1,
      init() {
        el.firstElementChild.style.backgroundImage =
          "url(" + el.firstElementChild.dataset.productImage + ")";
        this.available = el.dataset.available === "true";
      },
    };
  });
  Alpine.data("moleculeProductDetailPrice", (element) => {
    return {
      init() {
        let price = document.getElementById("detail-price");
        let comparePrice = document.getElementById("detail-compare-price");

        if (price != null) {
          price.innerText = element.dataset.price;
        }
        if (comparePrice != null) {
          comparePrice.innerText = element.dataset.comparePrice;
        }
      },
      updatePriceView(element) {
        let price = document.getElementById("detail-price");
        let comparePrice = document.getElementById("detail-compare-price");

        if (price != null) {
          price.innerText = element.price;
        }
        if (comparePrice != null) {
          comparePrice.innerText = element.compare_price;
        }
      },
    };
  });
  Alpine.data("templateProductDetailDillyClub", () => {
    return {
      step: 1,
      style: "",
      size: "",
      variantId: 0,
      init() {
        document
          .getElementById("outro")
          .appendChild(document.getElementById("cms"));
      },
      setStyle(style, event) {
        event.preventDefault();
        this.style = style;
        this.step = 2;
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 300);
      },
      setSize(size, variantId, event) {
        event.preventDefault();
        this.size = size;
        this.variantId = variantId;
        this.step = 3;
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 300);
      },
      goBack(event) {
        event.preventDefault();
        if (this.step > 1) {
          this.step = this.step - 1;
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 300);
        }
      },
    };
  });
  Alpine.data(
    "moleculeProductItemAddToCart",
    (defaultButtonLabel, defaultSelectLabel) => {
      return {
        defaultButtonLabel: "",
        defaultSelectLabel: "",
        setvariantevent: "setvariantevent",
        showVariants: false,
        productBought: false,
        forceShowVariants: false,
        disabled: true,
        activeVariant: {
          id: 0,
          title: "",
          price: 0.0,
          comparePrice: 0.0,
        },
        activeClass: "active",
        boughtClass: "success",
        hideClass: "disabled",
        stateIcon: "",
        init() {
          this.defaultButtonLabel =
            '<i class="atom-icon-fontawesome fa-regular fa-bag-shopping icon-left"></i><span class="label-text">' +
            defaultButtonLabel +
            "</span>";
          this.defaultSelectLabel =
            defaultSelectLabel +
            '<i class="atom-icon-fontawesome fa-regular fa-chevron-down icon-right"></i>';
          this.stateIcon =
            '<span class="atom-typography-label text-base text-start label-size-small label-spacing-packed">' +
            this.defaultButtonLabel +
            "</span>";
        },
        toggleShowVariants(event) {
          event.preventDefault();
          this.showVariants = !this.showVariants;
          if (this.showVariants) {
            this.defaultSelectLabel =
              defaultSelectLabel +
              '<i class="atom-icon-fontawesome fa-regular fa-chevron-up icon-right"></i>';
          } else {
            this.defaultSelectLabel =
              defaultSelectLabel +
              '<i class="atom-icon-fontawesome fa-regular fa-chevron-down icon-right"></i>';
          }
        },
        closeVariants() {
          this.showVariants = false;
          this.forceShowVariants = false;
        },
        setActiveVariant(variant) {
          // console.log(variant)
          // Detailpage to Buy
          this.activeVariant = variant;
          this.defaultSelectLabel =
            this.activeVariant.title +
            '<i class="atom-icon-fontawesome fa-regular fa-chevron-down icon-right"></i>';
          this.showVariants = false;
          this.disabled = false;
          // handle the active state of the selected variant
          Array.from(
            document.querySelectorAll(".size-availability-item")
          ).forEach((item) => {
            item.classList.remove("active");
            if (item.innerText.trim() == this.activeVariant.title) {
              item.classList.add("active");
            }
          });
        },
        buyVariant(event, itemId, quantity) {
          event.preventDefault();
          this.forceShowVariants = true;
          this.stateIcon =
            '<span class="atom-typography-label text-base text-start label-size-small label-spacing-packed "><i class="atom-icon-fontawesome fa-regular fa-rotate-right fa-spin icon-left"></i><span class="label-text">' +
            defaultButtonLabel +
            "</span></span>";

          Alpine.store("cart")
            .createCartLine(itemId, quantity)
            .then((data) => {
              this.productBought = true;
              this.stateIcon =
                '<span class="atom-typography-label text-base text-start label-size-small label-spacing-packed "><i class="atom-icon-fontawesome fa-regular fa-check icon-left"></i><span class="label-text">' +
                defaultButtonLabel +
                "</span></span>";
              setTimeout(() => {
                Alpine.store("global").productCanvas.hide();
              }, 750);
              setTimeout(() => {
                this.productBought = false;
                this.showVariants = false;
                this.forceShowVariants = false;
                this.stateIcon =
                  '<span class="atom-typography-label text-base text-start label-size-small label-spacing-packed ">' +
                  this.defaultButtonLabel +
                  "</span>";
                Alpine.store("cart").cartCanvas.show();
              }, 1000);
            })
            .catch((error) => console.log(error));
        },
      };
    }
  );
  Alpine.data("moleculeProductListItemVariantModalItem", () => {
    return {
      state: "",
      quantity: 1,
      showVariants: true,
      buyVariant(event, itemId, quantity) {
        event.preventDefault();
        this.state = "buying";

        Alpine.store("cart")
          .createCartLine(itemId, quantity)
          .then((data) => {
            this.state = "bought";
            setTimeout(() => {
              this.$refs.closeButton.click();
              this.state = "";
            }, 1000);
          })
          .catch((error) => console.log(error));
      },
    };
  });
  Alpine.data("moleculeCheckoutCartItem", (itemId) => {
    return {
      edit: false,
      loading: false,
      deleteItem(event) {
        event.preventDefault();
        this.loading = true;
        Alpine.store("cart").updateCartLine({ [itemId]: 0 });
      },
      updateItem(event) {
        this.loading = true;
        Alpine.store("cart").updateCartLine({
          [itemId]: event.detail.quantity,
        });
      },
    };
  });
  /* Alpine.data('moleculeCheckoutCartOversell', ()=>{
    return {
      timer:5,
      oversellItems:{},
      show:false,
      interval: null,
      init(){
        const component = this;
        
      if (component.interval !== null) {
        return;
      }
        Array.from(document.getElementsByClassName("molecule-checkout-cart-oversell-item")).forEach(
          function(element) {
            component.oversellItems[element.dataset["id"]] = 0;
            component.show = true;
          }
        );
        var interval = setInterval(function(){
          console.log('Timer:', component.timer);
          if(component.timer === 1){
            component.deleteItem()
            component.timer = 0
            console.log(component.timer)
            clearInterval(interval)
          }else{
            component.timer--;
          }
        }, 1000)
      },
      deleteItem(){
        console.log(222)
        Alpine.store('cart').updateCartLine(this.oversellItems);
        this.show = false;
      }
    }
  }); */
  Alpine.data("moleculeCheckoutCartQuantity", (initialCount, maxQuantity) => {
    return {
      quantity: 0,
      maxQuantity: 99,
      verifiedQuantity: 0, // as a backup for free invalid inputs
      init() {
        this.quantity = initialCount;
        this.verifiedQuantity = initialCount;
        if (maxQuantity != null) {
          this.maxQuantity = maxQuantity;
        }
      },
      incrementQuantity() {
        if (this.quantity < this.maxQuantity) {
          this.quantity = this.quantity + 1;
          this.verifiedQuantity = this.quantity;
          this.$el.dispatchEvent(
            new CustomEvent("update-quantity", {
              detail: { quantity: this.quantity },
              bubbles: true,
            })
          );
        }
      },
      decrementQuantity() {
        if (this.quantity > 1) {
          this.quantity = this.quantity - 1;
          this.verifiedQuantity = this.quantity;
          this.$el.dispatchEvent(
            new CustomEvent("update-quantity", {
              detail: { quantity: this.quantity },
              bubbles: true,
            })
          );
        }
      },
      setQuantity(input) {
        let quantity = parseInt(input.value); // will throw null if a string is in the field
        if (quantity) {
          // so you can here just ask for it
          if (quantity <= this.maxQuantity) {
            this.quantity = quantity;
          } else {
            this.quantity = this.maxQuantity;
          }
          this.$el.dispatchEvent(
            new CustomEvent("update-quantity", {
              detail: { quantity: this.quantity },
              bubbles: true,
            })
          );
        } else {
          this.quantity = this.verifiedQuantity;
        }
      },
    };
  });
  Alpine.data("organismCollectionBox", () => {
    return {
      init() {
        addEventListener("load", (event) => {
          this.adjustHeightOfCoverAndProductGrid();
        });
        addEventListener("resize", (event) => {
          this.adjustHeightOfCoverAndProductGrid();
        });
      },
      adjustHeightOfCoverAndProductGrid() {
        Alpine.store("global").equalHeight(
          this.$refs.organismCollectionBoxProductGrid,
          this.$refs.organismCollectionBoxCover,
          16
        );
      },
    };
  });
  Alpine.data("organismCollectionFilterBox", () => {
    return {
      colPosition: 0,
      maxColPosition: 0,
      navigationWidth: 0,
      init() {
        addEventListener("load", (event) => {
          this.updateNavigationWidth();
        });
        addEventListener("resize", (event) => {
          this.updateNavigationWidth();
        });
      },
      updateNavigationWidth() {
        this.navigationWidth = 50;
        for (let item of this.$refs.organismCollectionFilterBoxNavigation
          .children) {
          this.navigationWidth = this.navigationWidth + item.clientWidth;
          this.$refs.organismCollectionFilterBoxNavigation.style.width =
            this.navigationWidth + "px";
        }
      },
    };
  });
  Alpine.data("templateProductDetail", (el) => {
    return {
      quantity: 1,
      available: true,
      init() {
        this.available = el.dataset.available === "true";
      },
      updateItem(event) {
        this.quantity = event.detail.quantity;
      },
    };
  });
  Alpine.data("templateFaq", (el) => {
    return {
      search: "",
      filter: "",
      init() {},
      showItem(event) {
        return (
          this.search === "" ||
          event.textContent.includes(this.search) ||
          event.textContent.toLowerCase().includes(this.search) ||
          event.textContent.toUpperCase().includes(this.search)
        );
      },
      showCategory(event) {
        this.search = "";
        return this.filter === "" || event.dataset.filter === this.filter;
      },
      resetFilter() {
        this.filter = "";
      },
      resetSearch() {
        this.search = "";
      },
      setSearch(search) {
        this.filter = "";
        this.search = search;
      },
    };
  });
  Alpine.data("moleculeCustomerAddresses", (address) => {
    return {
      openNew: false,
      openDelete: false,
      openEdit: false,
      deleteId: null,
      loading: false,
      address: address,
      updateAddressesList(form) {
        event.preventDefault();
        let formData = new FormData(form);
        fetch(form.action, {
          method: "POST",
          body: formData,
        })
          .then((response) => response.text())
          .then((response) => {
            let b = Alpine.store("global")
              .fetchAndReplaceContent(
                Alpine.store("global").localizationUrl +
                  "?view=customer-addresses",
                "#customerAddressesList"
              )
              .then(() => {
                this.openNew = false;
                this.openEdit = false;
                this.openDelete = false;
                this.loading = false;
              });
          })
          .catch((error) => {
            console.error(error);
          });
      },
      saveAddress(form) {
        const valid = this.validateForm(form);
        if (valid) {
          this.loading = true;
          this.updateAddressesList(form);
        }
      },
      deleteUserAddress(address) {
        this.loading = true;
        this.updateAddressesList(address);
      },
      validateForm(form) {
        Array.from(document.getElementsByClassName("form-control")).map(
          (field) => {
            field.classList.remove("invalid-field");
            field.addEventListener("input", function () {
              field.parentNode.dataset.content = field.validationMessage;
            });
          }
        );
        const invalidFields = Array.from(form.querySelectorAll(":invalid")).map(
          (field) => {
            field.classList.add("invalid-field");
            field.parentNode.dataset.content = field.validationMessage;
          }
        );
        return invalidFields.length <= 0;
      },
    };
  });
  Alpine.data("moleculeFormLocalisation", () => {
    return {
      switchCountry(event, country_iso_code, language_iso_code) {
        event.preventDefault();
        this.$refs.lang_field.value = language_iso_code;
        this.$refs.country_field.value = country_iso_code;
        this.$refs.localisation_form.submit();
      },
      switchLocalization(event, country_iso_code, language_iso_code) {
        event.preventDefault();
        this.$refs.lang_field.value = language_iso_code;
        this.$refs.country_field.value = country_iso_code;
        this.$refs.localisation_form.submit();
      },
    };
  });

  // todo kibernetika - finished
  Alpine.data("moleculeFormSearch", () => {
    return {
      init() {
        const search = document.querySelector(".search-form .search-bar");
        const clearBtn = document.querySelector(".search-clear");
        let hideClearBtn;
        clearBtn.addEventListener("click", function (event) {
          event.preventDefault();
          search.value = "";
        });
        search.addEventListener("focus", function () {
          clearBtn.style.display = "flex";
          clearTimeout(hideClearBtn);
        });
        search.addEventListener("blur", function () {
          hideClearBtn = setTimeout(() => {
            clearBtn.style.display = "none";
          }, 100);
        });
      },
    };
  });
  Alpine.data("moleculeInstagramPhoto", (element) => {
    return {
      init() {
        Alpine.store("global").switchBackgroundImage(element);
      },
    };
  });
  Alpine.data(
    "moleculeCustomerLoggedOutBody",
    (showLoginForm, showRegisterForm, showRecoverForm) => {
      return {
        showLoginForm: false,
        showRegisterForm: false,
        showRecoverForm: false,
        init() {
          this.showLoginForm = showLoginForm;
          this.showRegisterForm = showRegisterForm;
          this.showRecoverForm = showRecoverForm;

          this.checkUrl(document.URL.split("#"));
        },
        checkUrl(urlArray) {
          switch (urlArray[1]) {
            case "recover":
              this.showLoginForm = false;
              this.showRegisterForm = false;
              this.showRecoverForm = true;
          }
        },
      };
    }
  );
  Alpine.data("boostProductItem", (boostFilterProductData) => {
    return {
      init() {
        // console.log(boostProductItem, boostFilterProductData)
      },
    };
  });
  Alpine.data("moleculeCard", () => {
    return {
      open: false,
      init() {},
      toggle() {
        this.open = !this.open;
      },
    };
  });
});
